export const frAddons = {
  souscriptions: {
    titre: 'Souscription de location',
    active: 'Renouvellement automatique',
    resiliee: 'Résiliée le {{date}}',
    suspendue: 'Souscription suspendue',
    close: 'Souscription close',
    resilier: 'Résilier',
    annulerResiliation: 'Annuler la résiliation',
    prochaine: 'Prochaine échéance le {{date}} au prix de {{prix}} HT',
    suspendre: 'Suspendre pour impayé',
    reactiver: 'Réactiver',
    confirmation_resilier: 'Effet à la fin de la période payée, le {{date}}, aucun remboursement.',
    'confirmation_annuler-resiliation':
      'Rétablir le renouvellement automatique à l’échéance du {{date}} ?',
    confirmation_suspendre:
      'Suspendre maintenant : lecture seule pendant 14 jours, données conservées, sans renouvellement.',
    confirmation_reactiver:
      'Ouvrir une nouvelle période maintenant, au tarif et à la remise en vigueur, et émettre sa facture ?',
    confirmer: 'Confirmer',
    erreur:
      'Impossible de modifier la souscription. Rechargez et vérifiez son état avant de recommencer.',
    raisons: {
      impaye: 'Impayé',
      galerie_inactive: 'Galerie inactive',
      addon_ferme: 'Add-on fermé, coupé ou droit remplacé',
      dependance_absente: 'Dépendance non effective',
      facturation_impossible: 'Facturation impossible',
      renouvellement_manque: 'Renouvellement manqué',
    },
  },
  venio: {
    titre: 'Facturation de Venio',
    raisonSociale: 'Raison sociale de Venio',
    formeJuridique: 'Forme juridique',
    capital: 'Capital (€)',
    siren: 'SIREN de Venio',
    siret: 'SIRET',
    tvaIntracom: 'TVA intracommunautaire de Venio',
    rcs: 'RCS',
    courriel: 'Courriel',
    iban: 'IBAN',
    bic: 'BIC',
    banque: 'Banque',
    delai: 'Délai de paiement (jours)',
    serie: 'Préfixe de série des factures',
    serieAvoir: 'Préfixe de série des avoirs',
    enregistrer: 'Enregistrer la facturation Venio',
    enregistre: 'Réglages enregistrés.',
    erreur:
      'Impossible de lire ou enregistrer les réglages. Vérifiez les champs et rechargez en cas de conflit.',
  },
  remise: {
    titre: 'Remise de la galerie',
    modifier: 'Modifier la remise',
    retirer: 'Retirer la remise',
    points: 'Remise (points de base)',
    valeur: 'Remise : {{points}} points de base',
  },

  prix: {
    titre: 'Prix',
    enVigueur: 'Version en vigueur',
    futures: 'Versions futures',
    historique: 'Historique des prix',
    version: 'Version {{version}}',
    nonVendue: 'Non vendue',
    mensuel: 'Mensuel HT (€)',
    annuel: 'Annuel HT (€)',
    achat: 'Achat HT (€)',
    essai: 'Durée d’essai (jours)',
    essaiValeur: 'Essai : {{jours}} jours',
    depuisLe: 'Date d’effet',
    ajouter: 'Nouvelle version de prix',
    supprimer: 'Supprimer la version future',
    confirmerSuppression: 'Confirmer la suppression de la version future',
    aide: 'Un montant vide signifie que la formule n’est pas vendue. Saisissez au plus deux décimales.',
    invalide: 'Vérifiez les montants, la durée et la date d’effet.',
    erreur: 'Impossible de charger les prix.',
  },
  facturation: {
    titre: 'Facturation Artosera',
    raisonSociale: 'Raison sociale',
    ligne1: 'Adresse',
    ligne2: 'Complément d’adresse',
    codePostal: 'Code postal',
    ville: 'Ville',
    pays: 'Pays (ISO à deux lettres)',
    siren: 'SIREN',
    tvaIntracom: 'Numéro de TVA intracommunautaire',
    emailFacturation: 'E-mail de facturation',
    verifiee: 'Numéro de TVA vérifié',
    nonVerifiee: 'Numéro de TVA non vérifié',
    sources: { console: 'Console', verificateur: 'Vérificateur' },
    verifier: 'Marquer le numéro de TVA vérifié',
    invalide: 'Vérifiez les coordonnées, le SIREN et le préfixe de TVA.',
    erreur: 'Impossible de charger la fiche de facturation.',
    reprendre: 'Reprendre le profil fiscal de la galerie',
    erreurProfil: 'Impossible de charger le profil fiscal de la galerie.',
    interdit: 'Cette page est réservée à la direction.',
    enregistrer: 'Enregistrer',
    enregistre: 'Fiche enregistrée.',
    demo: 'La modification est désactivée en démonstration.',
  },
  titre: 'Add-ons',
  bientot: 'Bientôt disponible',
  erreur: 'Impossible de charger les add-ons.',
  echec: 'Le changement a été refusé. Rechargez les droits puis réessayez.',
  charger: 'Chargement…',
  absent: 'Aucun droit',
  en_cours: 'En cours',
  echu: 'Échu',
  a_venir: 'À venir',
  modes: { achat: 'Achat', location: 'Location', essai: 'Essai', offert: 'Offert' },
  etats: { essai: 'Essai sur les espaces de test', publiee: 'Publié', fermee: 'Fermé' },
  attribuer: 'Attribuer',
  prolonger: 'Prolonger',
  convertir: 'Convertir',
  retirer: 'Retirer',
  mode: 'Mode',
  depuisLe: 'Depuis le',
  jusquAu: 'Jusqu’au',
  motif: 'Motif',
  auteur: 'Auteur',
  enregistrer: 'Enregistrer',
  annuler: 'Annuler',
  publication: 'Changer l’état de publication',
  confirmer: 'Je confirme la publication de {{addon}} pour les galeries clientes.',
  echeances: 'Droits qui échoient sous 30 jours',
  historique: 'Historique des publications',
  aucun: 'Aucun',
  sansEcheance: 'Sans échéance',
};
export const enAddons = {
  souscriptions: {
    titre: 'Rental subscription',
    active: 'Automatic renewal',
    resiliee: 'Cancelled effective {{date}}',
    suspendue: 'Subscription suspended',
    close: 'Subscription closed',
    resilier: 'Cancel subscription',
    annulerResiliation: 'Undo cancellation',
    prochaine: 'Next renewal on {{date}} at {{prix}} excluding VAT',
    suspendre: 'Suspend for non-payment',
    reactiver: 'Reactivate',
    confirmation_resilier: 'Effective at the end of the paid period, on {{date}}, with no refund.',
    'confirmation_annuler-resiliation': 'Restore automatic renewal on {{date}}?',
    confirmation_suspendre: 'Suspend now: read-only for 14 days, data preserved, with no renewal.',
    confirmation_reactiver:
      'Start a new period now at the current price and discount, and issue its invoice?',
    confirmer: 'Confirm',
    erreur: 'Unable to change the subscription. Reload and check its status before trying again.',
    raisons: {
      impaye: 'Non-payment',
      galerie_inactive: 'Inactive gallery',
      addon_ferme: 'Add-on closed, disabled or entitlement replaced',
      dependance_absente: 'Dependency not effective',
      facturation_impossible: 'Billing unavailable',
      renouvellement_manque: 'Missed renewal',
    },
  },
  venio: {
    titre: 'Venio billing',
    raisonSociale: 'Venio legal name',
    formeJuridique: 'Legal form',
    capital: 'Capital (€)',
    siren: 'Venio SIREN',
    siret: 'SIRET',
    tvaIntracom: 'Venio EU VAT number',
    rcs: 'Trade register',
    courriel: 'Email',
    iban: 'IBAN',
    bic: 'BIC',
    banque: 'Bank',
    delai: 'Payment term (days)',
    serie: 'Invoice series prefix',
    serieAvoir: 'Credit note series prefix',
    enregistrer: 'Save Venio billing',
    enregistre: 'Settings saved.',
    erreur: 'Unable to load or save settings. Check the fields and reload if they have changed.',
  },
  remise: {
    titre: 'Gallery discount',
    modifier: 'Edit discount',
    retirer: 'Remove discount',
    points: 'Discount (basis points)',
    valeur: 'Discount: {{points}} basis points',
  },

  prix: {
    titre: 'Prices',
    enVigueur: 'Current version',
    futures: 'Future versions',
    historique: 'Price history',
    version: 'Version {{version}}',
    nonVendue: 'Not sold',
    mensuel: 'Monthly excl. VAT (€)',
    annuel: 'Annual excl. VAT (€)',
    achat: 'Purchase excl. VAT (€)',
    essai: 'Trial duration (days)',
    essaiValeur: 'Trial: {{jours}} days',
    depuisLe: 'Effective date',
    ajouter: 'New price version',
    supprimer: 'Delete future version',
    confirmerSuppression: 'Confirm deletion of future version',
    aide: 'Leave a price blank for a plan that is not sold. Enter at most two decimal places.',
    invalide: 'Check prices, duration and effective date.',
    erreur: 'Unable to load prices.',
  },
  facturation: {
    titre: 'Artosera billing',
    raisonSociale: 'Legal name',
    ligne1: 'Address',
    ligne2: 'Address line 2',
    codePostal: 'Postal code',
    ville: 'City',
    pays: 'Country (two-letter ISO code)',
    siren: 'SIREN',
    tvaIntracom: 'EU VAT number',
    emailFacturation: 'Billing email',
    verifiee: 'VAT number verified',
    nonVerifiee: 'VAT number not verified',
    sources: { console: 'Console', verificateur: 'Verifier' },
    verifier: 'Mark VAT number as verified',
    invalide: 'Check contact details, SIREN and VAT prefix.',
    erreur: 'Unable to load billing details.',
    reprendre: 'Copy the gallery tax profile',
    erreurProfil: 'Unable to load the gallery tax profile.',
    interdit: 'This page is restricted to directors.',
    enregistrer: 'Save',
    enregistre: 'Billing details saved.',
    demo: 'Editing is disabled in demonstration mode.',
  },
  titre: 'Add-ons',
  bientot: 'Coming soon',
  erreur: 'Unable to load add-ons.',
  echec: 'The change was refused. Reload the entitlements and try again.',
  charger: 'Loading…',
  absent: 'No entitlement',
  en_cours: 'Current',
  echu: 'Expired',
  a_venir: 'Upcoming',
  modes: { achat: 'Purchase', location: 'Rental', essai: 'Trial', offert: 'Complimentary' },
  etats: { essai: 'Trial in test spaces', publiee: 'Published', fermee: 'Closed' },
  attribuer: 'Grant',
  prolonger: 'Extend',
  convertir: 'Convert',
  retirer: 'Withdraw',
  mode: 'Mode',
  depuisLe: 'From',
  jusquAu: 'Until',
  motif: 'Reason',
  auteur: 'Author',
  enregistrer: 'Save',
  annuler: 'Cancel',
  publication: 'Change publication state',
  confirmer: 'I confirm publication of {{addon}} for client galleries.',
  echeances: 'Entitlements expiring within 30 days',
  historique: 'Publication history',
  aucun: 'None',
  sansEcheance: 'No expiry',
};
